import React, { useEffect, useState } from 'react';

let listeners: ((msg: string, type: 'success' | 'error') => void)[] = [];

export function showToast(msg: string, type: 'success' | 'error' = 'success') {
  listeners.forEach(fn => fn(msg, type));
}

export function Toaster() {
  const [toast, setToast] = useState<{ msg: string; type: 'success' | 'error' } | null>(null);
  useEffect(() => {
    const handler = (msg: string, type: 'success' | 'error') => {
      setToast({ msg, type });
      setTimeout(() => setToast(null), 3500);
    };
    listeners.push(handler);
    return () => {
      listeners = listeners.filter(fn => fn !== handler);
    };
  }, []);
  if (!toast) return null;
  return (
    <div
      className={`fixed right-6 top-6 z-[9999] rounded-xl border px-6 py-3 text-base font-semibold shadow-lg transition-all duration-300 animate-toast-in
        ${toast.type === 'success' ? 'border-[#c7d6c9] bg-[#2f5d48] text-white' : 'border-[#f0b7b7] bg-[#c64545] text-white'}`}
      style={{ minWidth: 220, maxWidth: 400 }}
    >
      {toast.msg}
    </div>
  );
}

export function useToaster(setter: (msg: string, type: 'success' | 'error') => void) {
  useEffect(() => {
    listeners.push(setter);
    return () => {
      listeners = listeners.filter(fn => fn !== setter);
    };
  }, [setter]);
}
